// Copyright 2025-2026 - Hewlett Packard Enterprise Company
import { useContext } from 'react';
import { Grommet } from 'grommet';
import { deepMerge, normalizeColor } from 'grommet/utils';
import { hpe } from 'grommet-theme-hpe';

import { ThemeModeContext } from './providers/ThemeModeProvider';

// in theme v6 the background-back color was made gray and cards use contrast
// instead of elevation to achieve visual separation. It's anticipated that
// v9 grommet theme hpe will return to a white background-back color, so manually
// swapping the colors for now
const swappedBackgrounds = {
  global: {
    colors: {
      'background-back': {
        light: normalizeColor('background-front', hpe, false),
      },
      'background-front': {
        light: normalizeColor('background-back', hpe, false),
      },
    },
  },
  thumbsRating: {
    like: { color: 'text-strong' },
    dislike: { color: 'text-strong' },
  },
};

const resolvedTheme = deepMerge(hpe, swappedBackgrounds);

export default function ThemedApp({ children, theme: themeProp = undefined }) {
  const { themeMode } = useContext(ThemeModeContext);
  const activeTheme = themeProp ?? resolvedTheme;

  return (
    <Grommet
      theme={activeTheme}
      themeMode={themeMode}
      background={'background-back'}
    >
      {children}
    </Grommet>
  );
}
